import { motion, useReducedMotion } from 'framer-motion';
import { EASE, fadeUpItem, staggerParent } from '@/animations/variants';
import { Reveal } from '@/components/ui/Reveal';
import { menuItems } from '@/mocks/salonData';
import { asset } from '@/utils/assets';

export default function MenuSection() {
  const reduce = useReducedMotion();

  return (
    <section
      id="menu"
      className="py-20 sm:py-28 lg:py-36 bg-cream"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        {/* Header */}
        <Reveal className="mb-12 sm:mb-16">
          <p className="section-label mb-4">MENU & PRICE</p>
          <h2 className="font-serif-jp text-deep-brown text-xl sm:text-2xl lg:text-3xl leading-snug mb-4">
            人気メニュー TOP5
          </h2>
          <p className="font-sans-jp text-earth/85 text-sm sm:text-base">
            すべて税込価格です。追加料金は一切ございません。
          </p>
        </Reveal>

        {/* Menu Cards */}
        <Reveal className="space-y-8 sm:space-y-10" variants={{
          ...staggerParent,
          visible: { transition: { staggerChildren: 0.12, delayChildren: 0.05 } },
        }}>
          {menuItems.map((item) => (
            <motion.div
              key={item.id}
              className="bg-linen ring-1 ring-earth/10 shadow-sm hover:shadow-md overflow-hidden rounded-lg transition-shadow duration-300"
              variants={fadeUpItem}
              whileHover={reduce ? undefined : { y: -2 }}
              transition={{ duration: 0.3, ease: EASE }}
            >
              <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-0">
                {/* Image */}
                <div className="sm:col-span-1 lg:col-span-1 relative overflow-hidden">
                  <div className="w-full h-48 sm:h-full">
                    <motion.img
                      alt={item.name}
                      className="w-full h-full object-cover object-top"
                      src={asset(item.image)}
                      whileHover={reduce ? undefined : { scale: 1.04 }}
                      transition={{ duration: 0.6, ease: EASE }}
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="sm:col-span-2 lg:col-span-3 p-5 sm:p-6 lg:p-8 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-3 mb-3">
                      <motion.div
                        className="w-8 h-8 flex items-center justify-center rounded-full bg-forest"
                        variants={{
                          hidden: { opacity: 0, scale: reduce ? 1 : 0.85 },
                          visible: { opacity: 1, scale: 1, transition: { duration: 0.4, ease: EASE } },
                        }}
                      >
                        <span className="font-serif-jp text-white font-bold text-sm">{item.rank}</span>
                      </motion.div>
                      <h3 className="font-serif-jp text-deep-brown font-medium text-lg sm:text-xl">
                        {item.name}
                      </h3>
                    </div>
                    {item.subtitle && (
                      <p className="font-sans-jp text-earth/80 text-sm mb-3 ml-11">
                        {item.subtitle}
                      </p>
                    )}
                    <p className="font-sans-jp text-earth/85 text-sm leading-relaxed ml-11">
                      {item.description}
                    </p>
                  </div>
                  <div className="flex items-end justify-between mt-4 ml-11 pt-4 border-t border-earth/10">
                    <span className="font-sans-jp text-earth text-sm">
                      {item.time}
                    </span>
                    <span className="font-sans-jp text-deep-brown font-bold text-xl sm:text-2xl">
                      {item.price}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </Reveal>

        {/* Bottom note */}
        <Reveal className="mt-10 sm:mt-14 pt-8 border-t border-linen text-left">
          <p className="font-sans-jp text-earth/80 text-sm">
            ご予約・施術内容のご相談は、お電話またはホットペッパーにてお気軽にお問い合わせください。
          </p>
        </Reveal>
      </div>
    </section>
  );
}